<!--ZjPagination:组卷翻页样式 2022/09/28 14:44:09 YuAng-->

<template>
  <div class="zj-pagination">
    <el-pagination ref="pagination" background :hide-on-single-page="hideSinglePage" @current-change="currentChange"
      @size-change="sizeChange" :layout="`${showTotal ? 'total,' : ''}${(pageSizes.length > 1
        ? 'sizes,' : '')}prev, pager, next, jumper, slot`" :page-sizes="pageSizes" :total="page.total"
      :page-size="page.size ? page.size : 10" :current-page="page.current">
      <span class="jump-btn">确定</span>
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'ZjPagination',
  props: {
    page: {
      type: Object,
      default: function () {
        return {
          size: 10,
          total: 0,
          current: 1
        }
      }
    },
    pageSizes: {
      type: Array,
      default: function () {
        return [10]
      }
    },
    showTotal: {
      type: Boolean,
      default: false
    },
    hideSinglePage: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      tip: 'ZjPagination',
      count: 0
    }
  },
  mounted () {
    this.updateArrow()
  },
  methods: {
    currentChange: function (val) {
      this.$emit('current-change', val)
    },
    sizeChange: function (val) {
      this.$emit('size-change', val)
    },
    updateArrow: function () {
      if (this.count > 3) {
        this.count = 0
        return
      }
      setTimeout(() => {
        const left = this.$el.querySelector('.el-icon-arrow-left')
        if (left) {
          left.className = left.className + ' el-icon-caret-left'
          const right = this.$el.querySelector('.el-icon-arrow-right')
          right.className = right.className + ' el-icon-caret-right'
        } else {
          this.count = this.count + 0.5
          this.updateArrow()
        }
      }, 0.5 * 1000);
    }
  }
}
</script>

<style scoped>
.zj-pagination {
  height: 38px;
  overflow: hidden;
}

.zj-pagination ::v-deep .el-pagination {
  float: right;
  background: white;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
  border-radius: 14px;
  padding-left: 10px;
  padding-right: 10px;
}

.zj-pagination ::v-deep li {
  height: 22px;
  line-height: 22px;
  padding: 0 8px;
  margin-top: 3px !important;
  font-weight: normal;
  background-color: transparent !important;
  color: #666666;
  border: none !important;
}

.zj-pagination ::v-deep li:not(.disabled).active {
  background-color: #2877FF !important;
  border-radius: 8px;
}

.zj-pagination ::v-deep .btn-prev,
.zj-pagination ::v-deep .btn-next {
  height: 22px;
  min-width: 22px;
  line-height: 22px;
  border-radius: 50%;
  padding: 0;
  margin-top: 3px !important;
  color: #666666;
}

.zj-pagination ::v-deep .btn-prev:disabled,
.zj-pagination ::v-deep .btn-next:disabled {
  display: none;
}

.zj-pagination ::v-deep li.more::before {
  line-height: 24px;
}

.zj-pagination ::v-deep .el-input__inner {
  height: 22px;
}

span.jump-btn {
  color: white;
  background: #2877FF;
  text-align: center;
  font-size: 12px;
  border-radius: 8px;
  height: 22px;
  line-height: 22px;
  margin: 0 10px;
  margin-top: 3px;
  cursor: pointer;
}
</style>